import {
    ADD_USER_TO_TEAM,
    ADD_USER_TO_TEAM_FAIL,
    ADD_USER_TO_TEAM_SUCCESS,
    REMOVE_USER_FROM_TEAM,
    REMOVE_USER_FROM_TEAM_FAIL,
    REMOVE_USER_FROM_TEAM_SUCCESS,
    UPDATE_USER,
    UPDATE_USER_FAIL,
    UPDATE_USER_SUCCESS
} from './actionTypes';

const initialState = {
    user: {},
    updatedUser: {},
    error: null,
    loading: false,
    loaded: false
};

export function updateUserReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_USER:
        case ADD_USER_TO_TEAM:
        case REMOVE_USER_FROM_TEAM:
            return {
                ...initialState,
                user: action.payload,
                loading: true
            };
        case UPDATE_USER_SUCCESS:
        case ADD_USER_TO_TEAM_SUCCESS:
        case REMOVE_USER_FROM_TEAM_SUCCESS:
            return {
                ...state,
                updatedUser: action.payload,
                loaded: true,
                loading: false
            };
        case UPDATE_USER_FAIL:
        case ADD_USER_TO_TEAM_FAIL:
        case REMOVE_USER_FROM_TEAM_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
}
